import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '../context/AppContext';
import Currency from 'react-currency-formatter';
import localize from '../hoc/localize';

class CurrencyContainer extends Component {
    static propTypes = {
        quantity: PropTypes.number
    }
    render() {
        return (
            <AppContext.Consumer>
                {context => (
                    <Currency
                        quantity={this.props.quantity}
                        currency={context.state.currencyCode}
                        symbol={context.state.currencySymbol}
                        locale={this.props.uiLanguage} />
                )}

            </AppContext.Consumer>
        )
    }

}

export default localize(CurrencyContainer)
CurrencyContainer.contextType = AppContext;


// WEBPACK FOOTER //
// ./src/components/CurrencyContainer.js